((Account, $) => {
  'use strict';

  let $form;
  let $passwordRecovery;

  const cacheDom = () => {
    $form = $('#toggle-password-form');
    $passwordRecovery = $('.password-recovery');
  };

  const bindUIActions = () => {
    $form.on('click', () => {
      $passwordRecovery.slideToggle(200);
    });
  };

  const init = () => {
    cacheDom();
    bindUIActions();
  };

  Account.init = init;
})(window.Account = window.Account || {}, jQuery);
